import SelectBaseNormal from "~/components/SelectBase/normal";

const SelectNormal = SelectBaseNormal;

export default SelectNormal;